import apiClient from './apiClient';
import type { SenseCapDevice, SenseCapSamplesResponse } from '../types/types';

export type SenseCapSamplesFilters = {
    limit?: number;
    from?: string;
    to?: string;
};

const sensecapService = {
    getDevices: async (): Promise<SenseCapDevice[]> => {
        const res = await apiClient.get<SenseCapDevice[]>('/SenseCAP/devices');
        return res.data;
    },

    getSamples: async (
        devEui: string,
        filters?: SenseCapSamplesFilters,
    ): Promise<SenseCapSamplesResponse> => {
        const q = new URLSearchParams();
        if (filters?.limit != null) q.set('limit', String(filters.limit));
        if (filters?.from) q.set('from', filters.from);
        if (filters?.to) q.set('to', filters.to);
        const qs = q.toString();
        const url = `/SenseCAP/devices/${encodeURIComponent(devEui)}/samples${qs ? `?${qs}` : ''}`;
        const res = await apiClient.get<SenseCapSamplesResponse>(url);
        return res.data;
    },
};

export default sensecapService;
